/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { Routes, Route, Navigate, useParams } from "react-router-dom";

// Components
import List from "./Components/List";
import Viewer from "./Components/Viewer";
import HowItWorks from "./App/how-it-works";
import PrivacyPolicy from "./Components/Policy/PrivacyPolicy";
import CookiePolicy from "./Components/Policy/CookiePolicy";
import DisableHomePage from "./Components/DisableHomePage/DisableHomePage";

// APIs
import {
  getCartDynamicFieldApi,
  getCookieInfoApi,
  getPrivacyInfoApi,
  getSocialMediaPathApi,
} from "./Action";
import { GetNavigations } from "./Functions/functions";

/* ----------------------- Redirect Helpers ----------------------- */

const PdfSlugRedirect = () => {
  const { pdf_slug } = useParams();
  return <Navigate to={`/${pdf_slug}/page/1`} replace />;
};

const ComPdfSlugRedirect = () => {
  const { com_slug, pdf_slug } = useParams();
  return <Navigate to={`/${com_slug}/${pdf_slug}/page/1`} replace />;
};

/* ----------------------- Main Router ----------------------- */

const SubDomainRouter = ({ pdfList }) => {
  const clientID = pdfList?.[0]?.clientID;
  const com_slug = window.__E_TT_Client?.companySlug;
  const isHome = window.__E_TT_Client?.isHome;
  const isPublishHost = (() => {
    const publishHosts = [
      // "localhost",
      "publish.ecollat.com",
      "publish.ecollat.in",
    ];
    return publishHosts.includes(window.location.hostname);
  })();
  window.__E_TT_Client.isPublish = isPublishHost;
  const [cookiePolicyData, setCookiePolicyData] = useState("");
  const [privacyPolicyData, setPrivacyPolicyData] = useState("");
  const [socialMediaLinks, setSocialMediaLinks] = useState({});
  const [isPublish, setIsPublish] = useState(isPublishHost);

  /* ----------------------- Initial API Load ----------------------- */

  useEffect(() => {
    const loadInitialData = async () => {
      try {
        const [
          cookieRes,
          privacyRes,
          socialRes,
          cartRes,
        ] = await Promise.all([
          getCookieInfoApi(clientID),
          getPrivacyInfoApi(clientID),
          getSocialMediaPathApi(com_slug),
          getCartDynamicFieldApi(com_slug),
        ]);

        if (cookieRes?.success) setCookiePolicyData(cookieRes.data);
        if (privacyRes?.success) setPrivacyPolicyData(privacyRes.data);
        if (socialRes?.data) setSocialMediaLinks(socialRes.data);

        if (cartRes?.success) {
          const { priceValue, uiPriceField, belowTotalMrp } = cartRes.data || {};
          priceValue && localStorage.setItem("priceValue", priceValue);
          uiPriceField && localStorage.setItem("uiPriceField", uiPriceField);
          belowTotalMrp && localStorage.setItem("belowTotalMrp", belowTotalMrp);
        }
      } catch (err) {
        console.error("Initial data load failed:", err);
      }
    };

    loadInitialData();
  }, []);

  /* ----------------------- Shared Props ----------------------- */

  const sharedViewerProps = {
    cookiePolicyData,
    privacyPolicyData,
    socialMediaLinks,
  };

  const sharedListProps = {
    pdfs: pdfList,
    cookiePolicyData,
    privacyPolicyData,
    socialMediaLinks,
  };

  /* ----------------------- Routes ----------------------- */

  return (
    <Routes>
      {isPublish ? (
        <>
          {/* ---------------- Viewer ---------------- */}
          <Route
            path="/:com_slug/:pdf_slug/page/:pageNo"
            element={<Viewer {...sharedViewerProps} isPublish />}
          />
          <Route path="/:com_slug/:pdf_slug/page" element={<ComPdfSlugRedirect />} />
          <Route path="/:com_slug/:pdf_slug" element={<ComPdfSlugRedirect />} />

          {/* ---------------- Static Pages ---------------- */}
          <Route path="/:com_slug/how-it-works" element={<HowItWorks />} />
          <Route
            path="/:com_slug/privacy"
            element={<PrivacyPolicy privacyPolicyData={privacyPolicyData} />}
          />
          <Route
            path="/:com_slug/cookie"
            element={<CookiePolicy cookiePolicyData={cookiePolicyData} />}
          />

          {/* ---------------- Home Handling ---------------- */}
          <Route path="/:com_slug/homeRedirect" element={<DisableHomePage />} />

          <Route
            path="/:com_slug/"
            element={
              !isHome ? (
                <List {...sharedListProps} />
              ) : (
                <Navigate to={GetNavigations("homeRedirect")} replace />
              )
            }
          />
          <Route
            path="/:com_slug/*"
            element={
              <Navigate to="." replace />
            }
          />
          {/* <Route path="/" element={(window.location.replace("https://www.ecollat.com/"), null)} /> */}
        </>
      ) : (
        <>
          {/* ---------------- Viewer ---------------- */}
          <Route
            path="/:pdf_slug/page/:pageNo"
            element={<Viewer {...sharedViewerProps} isPublish={false} />}
          />
          <Route path="/:pdf_slug/page" element={<PdfSlugRedirect />} />
          <Route path="/:pdf_slug" element={<PdfSlugRedirect />} />

          {/* ---------------- Static Pages ---------------- */}
          <Route path="/how-it-works" element={<HowItWorks />} />
          <Route
            path="/privacy"
            element={<PrivacyPolicy privacyPolicyData={privacyPolicyData} />}
          />
          <Route
            path="/cookie"
            element={<CookiePolicy cookiePolicyData={cookiePolicyData} />}
          />

          {/* ---------------- Home Handling ---------------- */}
          <Route path="/homeRedirect" element={<DisableHomePage />} />

          <Route
            path="/"
            element={
              !isHome ? (
                <List {...sharedListProps} />
              ) : (
                <Navigate to={GetNavigations("/homeRedirect")} replace />
              )
            }
          />
        </>
      )}
    </Routes>
  );
};

export { SubDomainRouter };
